import React from "react";
import Loader from "./Loader";

const ExerciseVideo = ({ exerciseVideo, name }) => {
  // If exerciseVideo is empty or undefined, render Loader component
  if (!exerciseVideo?.length) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col md:p-5 p-2">
      {/* Title indicating the purpose of the component */}
      <h2 className="font-bold md:text-4xl text-2xl">
        Watch <span className="text-red-600">{name} </span> exercise videos
      </h2>
      <div className="flex my-10 flex-wrap md:p-5 overflow-hidden">
        {/* Render video thumbnails and details for the first 3 items in exerciseVideo */}
        {exerciseVideo?.slice(0, 3)?.map((item, index) => (
          <a
            key={index}
            className="w-full md:w-96 mx-1 my-8 md:h-56"
            href={`https://www.youtube.com/watch?v=${item?.video?.videoId}`}
            target="_blank"
            rel="noreferrer"
          >
            {/* Render video thumbnail */}
            <img
              style={{ borderRadius: "10px" }}
              src={item?.video?.thumbnails[0]?.url}
              alt={item?.video?.title}
              className="w-full object-cover"
            />
            {/* Render video title */}
            <p className="font-bold text-ellipsis overflow-hidden whitespace-nowrap text-lg">
              {item?.video?.title}
            </p>
            {/* Render video channel name */}
            <p> {item?.video?.channelName}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ExerciseVideo;
